import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Restaurants({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0002 2.66626C15.7911 2.66626 14.0002 4.45714 14.0002 6.6663V13.9997C14.0002 14.3679 14.2987 14.6664 14.6668 14.6664H18.0002V19.9998H16.6669V15.9997H15.3335V20.6664C15.3335 21.0346 15.632 21.3331 16.0002 21.3331H18.6669C19.0351 21.3331 19.3336 21.0346 19.3336 20.6664V3.33293C19.3336 2.96474 19.0351 2.66626 18.6669 2.66626H18.0002ZM18.0002 13.333V3.99961C16.5274 3.99961 15.3335 5.19353 15.3335 6.6663V13.333H18.0002Z"
        fill={iconColor}
      />
      <Path
        d="M6.00009 3.33293V9.99967C6.00009 10.3679 6.29857 10.6663 6.66677 10.6663H7.33344V4.66628H8.66679V10.6663H9.33346C9.70166 10.6663 10.0001 10.3679 10.0001 9.99967V3.33293H11.3335V9.99967C11.3335 11.1042 10.438 11.9997 9.33346 11.9997H7.33344V19.9998H8.66679V13.333H10.0001V20.6664C10.0001 21.0346 9.70166 21.3331 9.33346 21.3331H6.66677C6.29857 21.3331 6.00009 21.0346 6.00009 20.6664V11.8859C5.22329 11.6113 4.66675 10.8705 4.66675 9.99967V3.33293H6.00009Z"
        fill={iconColor}
      />
    </Svg>
  );
}
